// ========
// 下層
// ========
document.addEventListener('DOMContentLoaded', () => {
  const recEntry = document.querySelector('.js-recEntry')
  const recEntryBg = document.querySelector('.js-recEntryBg')
  if (!recEntry || !recEntryBg) return

  let lists = document.querySelectorAll('.js-recEntryBg__list')
  let itemWidth = document.querySelector('.js-recEntryBg__item')?.offsetWidth || 0

  const getInitialOffsets = (width) => {
    if (width >= 2000) return [0, 1]
    if (width >= 1201) return [2, 3]
    if (width >= 850) return [3, 5]
    if (width >= 769) return [4, 6]
    if (width >= 500) return [4, 6]
    if (width >= 420) return [6, 8]
    if (width >= 370) return [7, 9]
    return [8, 10]
  }

  const updateTransform = () => {
    const rect = recEntryBg.getBoundingClientRect()
    if (rect.top > window.innerHeight || rect.bottom < 0) return

    const [initialOffset, initialOffset02] = getInitialOffsets(window.innerWidth).map((v) => v * itemWidth)
    const moveDistance = window.scrollY * 0.1

    lists.forEach((list, index) => {
      list.style.transform = `translateX(${
        index % 2 === 0 ? initialOffset - moveDistance : -initialOffset02 + moveDistance
      }px)`
      list.style.transition = 'transform 0.1s ease-out'
    })
  }

  const checkScroll = () => {
    const rect = recEntry.getBoundingClientRect()
    recEntryBg.classList.toggle('is_active', rect.bottom > 0 && rect.top < window.innerHeight)
  }

  window.addEventListener('scroll', () => {
    updateTransform()
    checkScroll()
  })

  // リサイズ時に初期化＋再始動（0.5秒後）
  let resizeTimeout
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      // 初期化処理
      lists.forEach((list) => {
        list.style.transform = ''
        list.style.transition = ''
      })

      // 要素再取得（幅変わってるかも）
      itemWidth = document.querySelector('.js-recEntryBg__item')?.offsetWidth || 0
      lists = document.querySelectorAll('.js-recEntryBg__list')

      // 再始動
      updateTransform()
      checkScroll()
    }, 500)
  })

  checkScroll() // 初回チェック
})
